import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-outgoing-mail-icon',
  templateUrl: './communication-outgoing-mail.component.html'
})
export class CommunicationOutgoingMailComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
